<template>
    <section class="bg-900 pb-0 pt-5">

        <div class="container">
          <div class="row">
            <div class="col-6 col-sm-6 col-lg-4 mb-4 order-0 order-sm-0"><a class="text-decoration-none" href="#"><img src="../assets/img/gallery/logo-white.png" height="51" alt="" /></a>
              <p class="text-500 my-4">Solusi terbaik untuk <br> mutu perguruan tinggi terbaik.</p>
            </div>
            <div class="col-10 col-sm-8 col-lg-6 mb-3 order-2 order-sm-1">
              <ul class="list-unstyled mb-md-4 mb-lg-0">
                <li class="lh-lg"><a href="javascript:void()" class="text-500" style="text-decoration: none;"><i class="fas fa-map-marker-alt text-warning me-3"></i>Jl. Wahid Hasyim No. 06, Depok,</a></li>
                <li class="lh-lg"><a href="javascript:void()" class="text-500 mx-4" style="text-decoration: none;">Sleman, D.I. Yogyakarta.</a></li>
                <li class="lh-lg"><a href="javascript:void()" class="text-500" style="text-decoration: none;"><i class="fas fa-phone-alt text-warning me-3"></i>+62 8137 0000 475 (Whatsapp)</a></li>
                <li class="lh-lg"><a href="javascript:void()" class="text-500 mx-4" style="text-decoration: none;">&nbsp;Senin - Jum'at : 08.00 -16.30</a></li>
                <li class="lh-lg"><a href="javascript:void()" class="text-500" style="text-decoration: none;"><i class="fas fa-envelope text-warning me-3"> </i>jamitu.id@gmail.com</a></li>
              </ul>
            </div>
            <div class="col-6 col-sm-4 col-lg-2 mb-3 order-2 order-sm-1">
              <h5 class="lh-lg fw-bold mb-4 text-light font-sans-serif">Other links</h5>
              <ul class="list-unstyled mb-md-4 mb-lg-0">
                <li class="lh-lg"><a class="text-500" href="https://ecampuz.com/">Company</a></li>
                <li class="lh-lg"><a class="text-500" href="https://blog.ecampuz.com/">Blogs</a></li>
              </ul>
            </div>
            <!--div class="col-6 col-sm-4 col-lg-2 mb-3 order-3 order-sm-2">
              <h5 class="lh-lg fw-bold text-light mb-4 font-sans-serif">Services</h5>
              <ul class="list-unstyled mb-md-4 mb-lg-0">
                <li class="lh-lg"><a class="text-500" href="#!">Corporate goods</a></li>
                <li class="lh-lg"><a class="text-500" href="#!">Artworks</a></li>
                <li class="lh-lg"><a class="text-500" href="#!">Documents</a></li>
              </ul>
            </div>
            <div class="col-6 col-sm-4 col-lg-2 mb-3 order-3 order-sm-2">
              <h5 class="lh-lg fw-bold text-light mb-4 font-sans-serif"> Customer Care</h5>
              <ul class="list-unstyled mb-md-4 mb-lg-0">
                <li class="lh-lg"><a class="text-500" href="#!">About Us</a></li>
                <li class="lh-lg"><a class="text-500" href="#!">Contact US</a></li>
                <li class="lh-lg"><a class="text-500" href="#!">Get Update</a></li>
              </ul>
            </div-->
          </div>
        </div>
        <!-- end of .container-->

      </section>
</template>

<script>
export default {
    name : 'Link'
}
</script>